import { z } from 'zod';
import { outcomeSchema } from './outcome.js';
/** Obergrenze der Länge eines Bildtitels. */
export const MAX_TITLE_LENGTH = 200;
/** Verwendung eines Bildes in Wettbewerben. */
export const imageUsageSchema = z.object({
    /** Anzahl der Einreichungen des Bildes. */
    submissions: z.number().int(),
    /** Anzahl der Erfolge (Annahme oder besser). */
    accepted: z.number().int(),
});
/** Bild des Benutzers, wie die API es ausgibt (ohne Dateipfade). */
export const imageSchema = z.object({
    id: z.number().int(),
    title: z.string(),
    /** Standardkategorie des Bildes (optional). */
    category: z.string().nullable(),
    /** Ob eine Originaldatei vorhanden ist (Bilder aus dem Altbestand haben nur ein Thumbnail oder gar keine Datei). */
    hasOriginal: z.boolean(),
    hasThumb: z.boolean(),
    width: z.number().int().nullable(),
    height: z.number().int().nullable(),
    bytes: z.number().int().nullable(),
    createdAt: z.string(),
    usage: imageUsageSchema,
});
/** Abfrageparameter der Bildliste. */
export const imageListQuerySchema = z.object({
    q: z.string().trim().max(100).optional(),
    category: z.string().trim().max(100).optional(),
    /** `true`: nur Bilder ohne Einreichung. */
    unused: z.enum(['true', 'false']).optional(),
    limit: z.coerce.number().int().min(1).max(200).default(60),
    offset: z.coerce.number().int().min(0).default(0),
});
/** Antwort der Bildliste. */
export const imageListSchema = z.object({ items: z.array(imageSchema), total: z.number().int() });
/** Bild mit den zugehörigen Einreichungen (Detailansicht). */
export const imageDetailSchema = imageSchema.extend({
    submissions: z.array(z.object({
        competitionId: z.number().int(),
        competitionName: z.string(),
        outcome: outcomeSchema,
    })),
});
/** Änderung eines Bildes (Titel und/oder Standardkategorie). */
export const imagePatchBodySchema = z
    .object({
    title: z.string().trim().min(1, 'required').max(MAX_TITLE_LENGTH, 'too_long'),
    category: z.string().trim().max(100, 'too_long').nullable(),
})
    .partial();
/** Ergebnis eines hochgeladenen Bildes im Bulk-Upload. */
export const uploadResultSchema = z.object({
    filename: z.string(),
    /** `created` neu angelegt, `existing` war bereits vorhanden (gleiche Datei), `error` abgelehnt. */
    status: z.enum(['created', 'existing', 'error']),
    imageId: z.number().int().nullable(),
    title: z.string().nullable(),
    /** Fehlercode bei `status = error` (z. B. `image_invalid`, `title_taken`). */
    code: z.string().nullable(),
    /** Einreichung im Wettbewerb (nur beim Upload über einen Wettbewerb). */
    submissionId: z.number().int().nullable().default(null),
});
/** Antwort des Bulk-Uploads. */
export const uploadResponseSchema = z.object({ results: z.array(uploadResultSchema) });
/** Zusatzangaben zu einer hochgeladenen Datei (Feld `meta`, direkt vor der Datei gesendet). */
export const uploadMetaSchema = z.object({
    title: z.string().trim().min(1).max(MAX_TITLE_LENGTH).optional(),
    category: z.string().trim().max(100).nullable().optional(),
});
/** Zusammenführen: das Bild wird mit seinen Einreichungen in das Zielbild überführt und gelöscht. */
export const imageMergeBodySchema = z.object({ targetId: z.number().int().positive() });
//# sourceMappingURL=images.js.map